export default "__VITE_ASSET__BBOCW9tV__"